var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFooter3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.013,
    height: 51.087,
    viewBox: "0 0 51.013 51.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#36c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M664.335,2841.4a1.465,1.465,0,0,1,1.682-1.186,16.78,16.78,0,0,1,13.672,13.671,1.46,1.46,0,0,1-1.2,1.685,2.2,2.2,0,0,1-.249.021,1.446,1.446,0,0,1-1.433-1.209,13.881,13.881,0,0,0-11.3-11.3A1.441,1.441,0,0,1,664.335,2841.4Z",
    transform: "translate(-637.939 -2830.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M690.248,2877.39c-.463.485-.937.947-1.4,1.39a24.954,24.954,0,0,0-1.888,1.952c-.01.022-.031.032-.042.053a8.122,8.122,0,0,1-6.221,2.674c-.216,0-.452-.011-.679-.021a26.321,26.321,0,0,1-9.488-2.8,50.736,50.736,0,0,1-16.9-13.229,46.4,46.4,0,0,1-8.249-13.758,18.913,18.913,0,0,1-1.38-8,7.892,7.892,0,0,1,2.34-5.015l3.666-3.7.02-.02a5.28,5.28,0,0,1,3.667-1.588,5.1,5.1,0,0,1,3.611,1.588c.7.646,1.38,1.335,2.027,2,.324.344.669.69,1,1.023l2.944,2.944a4.948,4.948,0,0,1,0,7.462c-.3.3-.6.614-.906.917-.8.809-1.618,1.648-2.5,2.456a21.838,21.838,0,0,0,2.912,4.595,36.986,36.986,0,0,0,8.873,8.086c.313.2.681.379,1.068.571.27.142.55.282.831.433l3.407-3.4a5.19,5.19,0,0,1,3.688-1.661,5.024,5.024,0,0,1,3.644,1.67l5.919,5.941a5.179,5.179,0,0,1,1.661,3.7A5.379,5.379,0,0,1,690.248,2877.39Z",
    transform: "translate(-643.96 -2832.373)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M687.649,2857.244a2.14,2.14,0,0,1-.248.022,1.447,1.447,0,0,1-1.434-1.208,24.673,24.673,0,0,0-20.12-20.119,1.455,1.455,0,0,1,.474-2.87,27.633,27.633,0,0,1,22.514,22.514A1.428,1.428,0,0,1,687.649,2857.244Z",
    transform: "translate(-637.845 -2833.048)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFooter3);
export default __webpack_public_path__ + "static/media/icon-footer3.72efe2a0bf186eeff0ce7f154c41b657.svg";
export { ForwardRef as ReactComponent };